import { LocalStorageKeys } from '@/app.constants';
import { store } from '@/store';
import Utils from '@/Utils';
import PhoneNumber from 'awesome-phonenumber';
import axios from 'axios';
import PortalVue from 'portal-vue';
import VeeValidate, { Validator } from 'vee-validate';
import Vue from 'vue';
import VModal from 'vue-js-modal';
import VueTheMask from 'vue-the-mask';
import Toasted from 'vue-toasted';
import App from './App.vue';
import router from './router';
import './utils/iconHelper';

const search: string = location.search;
if (search.indexOf('token')) {
  const query: any = Utils.fromQueryString(location.search.substring(1));
  if (query.token) {
    localStorage.setItem(LocalStorageKeys.jwt, query.token);
    store.setJwt(query.token);

    history.replaceState({}, '', window.location.href.split('?')[0]);
  }
}

const token = localStorage.getItem(LocalStorageKeys.jwt);

// set default axios headers
if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

const phoneNumber = {
  // getMessage: field => `Please enter a valid phone number`,
  validate(value: number) {
    return new Promise(resolve => {
      const phone = new PhoneNumber('+1' + value);
      resolve({ valid: phone.isValid() });
    });
  },
};

Vue.config.productionTip = false;
Vue.use(VeeValidate);
// We gotta ignore this for some reason. Maybe it'll be fixed when a new version is released.
// @ts-ignore
Vue.use(Toasted);
Vue.use(VueTheMask);
Vue.use(PortalVue);
Vue.use(VModal);

Validator.extend('phoneNumber', (phoneNumber as any));

new Vue({
  render: h => h(App),
  router,
}).$mount('#app');
